var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRightToLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H17.875V19.5H19.5V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60113 6.02387L11.5148 8.9375L1.42062e-07 8.9375L0 10.5625L11.5147 10.5625L8.60112 13.4761L9.75 14.625L14.625 9.75L9.75 4.875L8.60113 6.02387Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightToLine);
export default __webpack_public_path__ + "static/media/ic-arrow-right-to-line.4e8858085eaf63c2b436f5fceb2d05f1.svg";
export { ForwardRef as ReactComponent };